// Auth
export const ROUTING_LOGIN = "/login";

// Dashboard
export const ROUTING_CHATBOT = "/";

const ROUTES = {
  LOGIN: ROUTING_LOGIN,
  CHATBOT: ROUTING_CHATBOT
};

export default ROUTES;
